// <copyright file="frame-version-reasons.ts" company="SoftTech Ltd">
// Copyright (c) SoftTech Ltd. All rights reserved.
// </copyright>

import { LangFranchiseeQuoteManager } from '../../../../localization/scripts/dealer-franchisee/quotes/data/franchisee-quote-manager-lang';

/**
 * Why a frame is out of date on its versions. The supplier's update message shows whenever the system version moved
 * (or the branch version moved but its numbers are unknown); the Dealership Branch line, with both versions, is
 * added when the branch's customer code version moved (SUPVER-008).
 */
export function frameVersionReasons(
  position: number,
  isSystemVersionCurrent: boolean,
  customerVersions: { itemVersion: number; currentVersion: number } | undefined
): string[] {
  const reasons: string[] = [];
  if (!isSystemVersionCurrent || !customerVersions)
    reasons.push(LangFranchiseeQuoteManager.frameOutOfDateNeedsUpdate({ position }));
  if (customerVersions)
    reasons.push(LangFranchiseeQuoteManager.frameOutOfDateCustomerVersion({ position, ...customerVersions }));
  return reasons;
}
